import { render, staticRenderFns } from "./ProductNew.vue?vue&type=template&id=71ed9a9a&scoped=true"
import script from "./ProductNew.vue?vue&type=script&lang=js"
export * from "./ProductNew.vue?vue&type=script&lang=js"
import style0 from "./ProductNew.vue?vue&type=style&index=0&id=71ed9a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed9a9a",
  null
  
)

export default component.exports